import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import { TileJSON } from "ol/source";

const urlTempl = process.env.REACT_APP_HIGH_RES_SATELITE_API_URL_TEMPLATE!;
const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN!;
const mapboxSatelliteUrl = `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@2x.jpg90?access_token=${mapboxToken}`;

/*
 * The satellite imagery under both Fields maps (main map and compare pane),
 * which each used to build their own copy: high-res tiles from z12, the
 * Mapbox satellite fallback above z18 (bug-077: the compare pane once dropped
 * it and went blank when zoomed in), and the low-res base up to z13. Each map
 * needs its own instances — OpenLayers cannot share a layer between maps.
 */

export const createSatelliteLayer = () =>
  new TileLayer({
    source: new XYZ({
      url: urlTempl,
      maxZoom: 18,
    }),
    minZoom: 12,
  });

export const createMapboxFallbackLayer = () =>
  new TileLayer({
    source: new XYZ({
      url: mapboxSatelliteUrl,
      maxZoom: 22,
      tileSize: 512,
    }),
    minZoom: 18,
  });

export const createLowResBaseLayer = () =>
  new TileLayer({
    source: new TileJSON({
      url: process.env.REACT_APP_LOW_RES_SATELITE_API_URL!,
      tileSize: 512,
      crossOrigin: "anonymous",
    }),
    maxZoom: 13,
  });

/** [satellite, mapbox fallback, low-res base], in map stacking order. */
export const createBaseImageryLayers = () =>
  [createSatelliteLayer(), createMapboxFallbackLayer(), createLowResBaseLayer()] as const;
